import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-between items-center w-full" }
const _hoisted_2 = { class: "flex flex-row gap-1 items-center" }
const _hoisted_3 = { class: "title" }

import { computed, ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";

import { toast } from "@/common/utils/toast";

import {
  methodFieldList,
  methodFieldShow,
  methodFieldCreate,
  methodFieldUpdate,
  methodFieldDelete,
} from "@/common/api/rest/method/method-field";

import type {
  MethodFieldType,
  MethodFieldPayloadType,
} from "@/common/types/method/method-field";

import { RegisterTheme } from "@/common/themes";
import { iconMenu, svgIcon } from "@/common/components";

import { methodFieldForm } from "@/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'field',
  setup(__props) {

const { t, tm } = useI18n();
const router = useRouter();
const route = useRoute();

const fieldData = ref<MethodFieldType[]>([]);

const accountId = computed(() => String(route.params.id));
const groupId = computed(() => String(route.params.group));

const menuTabs = computed(() => [
  {
    key: "edit",
    icon: "home-line",
    label: t("common.labels.group"),
  },
  {
    key: "field",
    icon: "field",
    label: t("common.labels.fields"),
  },
  {
    key: "method",
    icon: "method",
    label: t("common.labels.methods"),
  },
  {
    key: "question",
    icon: "form",
    label: t("common.labels.questions"),
  },
]);

function back() {
  router.push(`/${accountId.value}/register/method`);
}

function goToTab(tab: string) {
  router.push(`/${accountId.value}/register/method/${groupId.value}/${tab}`);
}

function fetchFields() {
  methodFieldList(accountId.value, groupId.value, {
    page: 0,
    limit: 500,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        fieldData.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

// FIELDS
function addField(field: MethodFieldPayloadType) {
  methodFieldCreate(accountId.value, groupId.value, field)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchFields();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function editField(field: MethodFieldType) {
  methodFieldUpdate(accountId.value, field.field_id, field)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchFields();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function delField(field: MethodFieldType) {
  methodFieldDelete(accountId.value, field.field_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchFields();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

onMounted(() => {
  fetchFields();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(RegisterTheme), { "tab-active": "method" }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(svgIcon), {
            icon: "method",
            size: "2rem"
          }),
          _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.edit", { concat: _unref(t)("common.labels.method") })), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-back btn-sm",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
        }, [
          _createVNode(_unref(svgIcon), {
            icon: "close",
            size: "1.25rem"
          })
        ])
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_unref(iconMenu), {
        tabs: menuTabs.value,
        active: "field",
        onSelected: _cache[1] || (_cache[1] = ($event: any) => (goToTab($event)))
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("common.labels.fields")), 1),
          _createVNode(_unref(methodFieldForm), {
            data: fieldData.value,
            onAdd: addField,
            onEdit: editField,
            onDel: delField
          }, null, 8, ["data"])
        ]),
        _: 1
      }, 8, ["tabs"])
    ]),
    _: 1
  }))
}
}

})